import { ArchiAppID } from './archiAppsTypes';

const basePath = '/archi-apps';

export class ArchiAppPath {
  static index() {
    return basePath;
  }

  static aiStudio() {
    return `/ai-studio`;
  }

  static editAiStudio() {
    return `/ai-studio/edit`;
  }

  static show(archiAppId: ArchiAppID) {
    return `${basePath}/${archiAppId}`;
  }
}
